import { analysisArticles } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function AnalysisSection() {
  return (
    <section id="analysis" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          index="05"
          eyebrow="Deep Analysis"
          title="源头梳理与深度分析"
          desc="不是复述热度，而是回到源头把证据按顺序摆好，再解释每一步为什么重要。"
        />

        <div className="grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {analysisArticles.map((article) => (
            <a
              key={article.id}
              href="#timeline"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-48 w-full overflow-hidden md:h-52">
                <img
                  src={article.image}
                  alt={`${article.title} 配图`}
                  title={`蝌蚪黑料 ${article.tag} 深度分析`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <span className="inline-flex w-fit rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">
                  {article.tag}
                </span>
                <h3 className="mt-4 font-heading text-lg leading-snug text-foreground-950">
                  {article.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 font-label text-xs text-foreground-500">
                  <span className="truncate">{article.author}</span>
                  <span className="flex shrink-0 items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-sm" />
                      {article.reads}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-sm" />
                      {article.minutes} 分钟
                    </span>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}